import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import classNames from "classnames";
import isEmpty from "is-empty";

import LegalInformation from '../../shared/components/notices/BottomLegalInformation';
import { userLogin } from "../../user/actions";
import logo from "../../../assets/images/branding/logo-blue.svg";
import { TrackEventName, PageViewName } from '../../shared/constants/SegmentEvents';
import { segmentEventTracker } from '../../../utils/SegmentEventTracker';
import FullPageLayout from "../../shared/components/layouts/FullPageLayout";

// TODO: Refactor this container
// Take this out of home directory

export class LoginScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      loading: false,
      error: {},
    };
  }

  componentDidMount() {
    segmentEventTracker.trackPageView(PageViewName.LOGIN_VIEWED);
  }

  initializeZendesk = () => { if(!window.zE) return;
    window.zE(function() {
      window.zE('webWidget', 'clear');
      window.zE.logout();
      window.zE('webWidget', 'reset');
      window.zE('webWidget', 'hide');
    });

    window.zESettings = {
      webWidget: {
        chat: {
          suppress: true
        },
      }
    };
  }

  submitButtonClassnames() {
    return classNames(
      "ds-btn",
      "--medium",
      "--full",
      {"_loading": this.state.loading},
    );
  }

  // Separate per event when needed
  // for now, we can just call this method
  trackEvent(eventName) {
    segmentEventTracker.trackEvent(eventName);
  }

  onLogin = () => {
    const onSuccess = () => this.setState({ loading: false });
    const onError = (error) => this.setState({ loading: false, error });

    this.trackEvent(TrackEventName.LOGIN_CLICKED);

    this.setState({ loading: true });
    this.props.userLogin(
      this.state.username,
      this.state.password,
      onSuccess,
      onError,
    );
  }

  updateUsername = (e) => {
    this.setState({username: e.target.value.toLowerCase()});
  }

  updatePassword = (e) => {
    this.setState({password: e.target.value});
  }

  submitToLogin = (e) => {
    if(e.keyCode === 13) {
      this.onLogin()
    }
  }

  get concatenatedUTMParams() {
    return this.props.location.search;
  }

  renderError() {
    return (
      <section data-test="error-section" className="cardSection ds-notice -danger">
        <p className="copy">Your email or password is incorrect.</p>
        <Link
          to={{pathname: '/forgot_password', search: `email=${this.state.username}`}}
          className='ds-btn -inverted -danger'
          data-testid="request-new-password-button"
          onClick={() => this.trackEvent(TrackEventName.REQUEST_NEW_PASSWORD_CLICKED)}
        >
          Request new password
        </Link>
      </section>
    );
  }

  render() {
    this.initializeZendesk();

    const { from } = this.props.location.state || { from: { pathname: "/" } };
    if (!!this.props.auth_token) return <Redirect to={from} />;

    return (
      <FullPageLayout gridClassName="--narrow _marginTop--xxlarge">
        <div className="ds-container _addButtonPadding">
          <div className="grid --narrow">
            <div className="logo --small _marginTop--large _marginBottom--normal">
              <img
                src={logo}
                alt="Logo"
              />
            </div>
            <div className="ds-card _solo">
              {!isEmpty(this.state.error) && this.renderError()}
              <section className="cardSection">
                <h1 className="subhead">Log In to First Circle</h1>
              </section>
              <section className="cardSection">
                <label className="ds-input" htmlFor="user_login">
                  <span>Email Address</span>
                  <input
                    type="email"
                    placeholder="Enter Email Address"
                    value={this.state.username}
                    id="user_login"
                    onChange={this.updateUsername}
                    onKeyDown={this.submitToLogin}
                    data-testid="email-input"
                  />
                </label>
                <label className="ds-input" htmlFor="user_password">
                  <span>Password</span>
                  <input
                    placeholder="Enter Password"
                    type="password"
                    id="user_password"
                    value={this.state.password}
                    onChange={this.updatePassword}
                    onKeyDown={this.submitToLogin}
                    data-testid="password-input"
                  />
                </label>
              </section>
              <button
                type="submit"
                data-testid="login-button"
                className={this.submitButtonClassnames()}
                onClick={this.onLogin}
                disabled={this.state.loading}
              >
                Log In
              </button>
            </div>

            <p className="byline _alignCenter">
              No account yet? <Link
                to={{pathname: '/apply', search: this.concatenatedUTMParams }}
                className="inlineLink"
                data-testid="register-here-button"
                onClick={() => this.trackEvent(TrackEventName.REGISTER_HERE_CLICKED)}
              >
                Register here!
              </Link>
            </p>
            <Link
              to={{pathname: '/forgot_password', search: `email=${this.state.username}`}}
              className="ds-btn _link --small _marginBottom--large"
              data-testid="forgot-password-button"
              onClick={() => this.trackEvent(TrackEventName.FORGOT_PASSWORD_CLICKED)}
            >
              Forgot password?
            </Link>

            <br/>
            <LegalInformation />
          </div>
        </div>
      </FullPageLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth_token: state.user.auth_token,
    fc_lead: state.fc_lead
  };
};
const mapDispatchToProps = (dispatch, props) => {
  return {
    userLogin: (username, password, onSuccess, onError) => dispatch(userLogin(username, password, onSuccess, onError))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);



// WEBPACK FOOTER //
// ./src/features/home/containers/LoginScreen.js